import { queryOptions, useQuery } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import queryClient from '#/api/queryClient';

const method = api.getLoansCustomerPortfolio;
type LoanOverviewResponse = api.PortfolioInfoResponse;
export type RequestOpts = Omit<RequestInit, 'body' | 'headers'> & {
  priority?: 'high' | 'low';
};

type GetLoanPortfolioQueryParams = {
  filterDate?: string | null | undefined;
};

function getLoanPortfolioQuery(
  params?: GetLoanPortfolioQueryParams,
  opts: RequestOpts = {},
) {
  const queryKey = ['loanportfolio', params?.filterDate ?? 'no-date'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return method(
        { filterDate: params?.filterDate ?? undefined },
        { ...opts, signal },
      ) as unknown as Promise<LoanOverviewResponse>;
    },
  });
}

export async function fetchLoanPortfolioQuery(
  params?: GetLoanPortfolioQueryParams,
  opts: RequestOpts = {},
) {
  return queryClient.fetchQuery(getLoanPortfolioQuery(params, opts));
}

export function useLoanPortfolio(
  params: GetLoanPortfolioQueryParams,
  options: Omit<ReturnType<typeof getLoanPortfolioQuery>, 'queryKey'> = {},
) {
  const query = getLoanPortfolioQuery(params);
  return useQuery({
    ...query,
    staleTime: ms('30s'),
    initialDataUpdatedAt: queryClient.getQueryState(query.queryKey)
      ?.dataUpdatedAt,
    ...options,
  });
}
